export const HEADER_COLOR = '#add8e6';
export const PAGE_BORDER_WIDTH = 2;
export const FULL_WIDTH = 355 - PAGE_BORDER_WIDTH * 2;
export const FULL_HEIGHT = 216;
export const SECTION_GAP_WIDTH = 2;
export const LINE_Y_OFFSET = 0.5;
export const HEADER_HEIGHT = 24;
export const HEADER_WIDTH = FULL_WIDTH;
export const HEADER_LEFT = PAGE_BORDER_WIDTH;
export const HEADER_TOP = PAGE_BORDER_WIDTH;
export const ROW_SECTION_HEADER_HEIGHT = 4;
export const THIN_LINE = 0.25;
export const THICK_LINE = 0.5;

export const HEADER_1_SIZE = 9;
export const HEADER_2_SIZE = 7;
export const LOGO_LEFT = 2;
export const LOGO_TOP = PAGE_BORDER_WIDTH;
export const LOGO_WIDTH = 50;
export const LOGO_HEIGHT = 23;

export const OPERATOR_CONTRACTOR_TOP = PAGE_BORDER_WIDTH + 2;
export const OPERATOR_CONTRACTOR_LEFT = PAGE_BORDER_WIDTH + LOGO_WIDTH + 10;
export const OPERATOR_CONTRACTOR_WIDTH = 230;
export const OPERTAOR_CONTRACTOR_HEIGHT = 20;

export const DEPTH_TOP = PAGE_BORDER_WIDTH + 2;
export const DEPTH_LEFT = OPERATOR_CONTRACTOR_LEFT + OPERATOR_CONTRACTOR_WIDTH;
export const DEPTH_WIDTH = FULL_WIDTH - DEPTH_LEFT - PAGE_BORDER_WIDTH;
export const DEPTH_HEIGHT = OPERTAOR_CONTRACTOR_HEIGHT;

export const ROW_HEADERS_BIG_TOP = HEADER_TOP + HEADER_HEIGHT + ROW_SECTION_HEADER_HEIGHT;
export const ROW_HEADERS_BIG_LEFT = PAGE_BORDER_WIDTH;
export const ROW_HEADERS_BIG_WIDTH = 115;
export const ROW_HEADERS_BIG_HEIGHT = 10;

export const INDENT_WIDTH = 3;

export const EXTERNAL_STORAGE_TOP = ROW_HEADERS_BIG_TOP + ROW_HEADERS_BIG_HEIGHT + SECTION_GAP_WIDTH;
export const EXTERNAL_STORAGE_LEFT = ROW_HEADERS_BIG_LEFT;
export const EXTERNAL_STORAGE_WIDTH = ROW_HEADERS_BIG_WIDTH;
export const EXTERNAL_STORAGE_HEIGHT = FULL_HEIGHT - EXTERNAL_STORAGE_TOP;
export const EXTERNAL_STORAGE_ROWS = 35;

export const COLUMN_WIDTH = 17;
export const COLUMN_START_LEFT = ROW_HEADERS_BIG_LEFT + ROW_HEADERS_BIG_WIDTH;


// WEBPACK FOOTER //
// ./src/Services/Pdf/VolumeAccountingReport/SpecMilsExternal.ts